export function Section({ title, hint, children, testid, action }) {
  return (
    <section className="gi-card p-5 sm:p-6" data-testid={testid}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          <h2 className="font-display text-lg font-bold text-ink">{title}</h2>
          {hint && <p className="text-sm text-body mt-0.5">{hint}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}

export function Field({ id, label, value, onChange, placeholder, textarea, rows = 4, maxLength = 160, className = "", type = "text" }) {
  const common = { id, "data-testid": id, value: value || "", maxLength, placeholder, onChange: (e) => onChange(e.target.value) };
  return (
    <div className={className}>
      <label htmlFor={id} className="gi-label">{label}</label>
      {textarea
        ? <textarea {...common} rows={rows} className="gi-input resize-y leading-relaxed" />
        : <input {...common} type={type} className="gi-input" />}
    </div>
  );
}

export function AboutSection({ p, onChange }) {
  const f = (k, label, placeholder, extra = {}) => (
    <Field id={`profile-${k}`} label={label} placeholder={placeholder} value={p[k]} onChange={(v) => onChange(k, v)} {...extra} />
  );
  return (
    <Section title="About you" hint="This goes at the top of your CV." testid="profile-about">
      <div className="grid sm:grid-cols-2 gap-4">
        {f("name", "Full name", "e.g. Priya Nair", { maxLength: 120 })}
        {f("headline", "Headline", "e.g. Marketing Executive")}
        {f("phone", "Phone", "e.g. +65 9123 4567", { maxLength: 40, type: "tel" })}
        {f("location", "Location", "e.g. Singapore", { maxLength: 120 })}
        {f("linkedin", "LinkedIn profile link", "e.g. linkedin.com/in/your-name", { maxLength: 200 })}
        {f("target_roles", "Roles you want next", "e.g. Brand Manager, Marketing Lead", { maxLength: 300 })}
        {f("summary", "A few lines about you", "What you're good at, your experience and what you're looking for. Your own words are fine; we'll polish them.", { textarea: true, maxLength: 3000, className: "sm:col-span-2" })}
      </div>
    </Section>
  );
}

export function SkillsSection({ p, onChange }) {
  const skills = (p.skills || "").split(",").map((s) => s.trim()).filter(Boolean);
  return (
    <Section title="Skills and certifications" hint="Only add what you can talk about in an interview." testid="profile-skills-section">
      <div className="space-y-4">
        <Field id="profile-skills" label="Skills, separated by commas" placeholder="e.g. Social media marketing, Canva, Budget management" value={p.skills} onChange={(v) => onChange("skills", v)} maxLength={1500} />
        {skills.length > 0 && (
          <ul className="flex flex-wrap gap-2" data-testid="profile-skill-chips">
            {skills.slice(0, 30).map((s, i) => <li key={`${s}-${i}`} className="px-3 py-1 rounded-full bg-brand-soft text-brand-text text-sm font-medium">{s}</li>)}
          </ul>
        )}
        <Field id="profile-certifications" label="Certifications, one per line" placeholder={"e.g. Google Analytics Certification\nWSQ Digital Marketing"} value={p.certifications} onChange={(v) => onChange("certifications", v)} textarea rows={3} maxLength={1500} />
      </div>
    </Section>
  );
}
